<template>
  <section>
    <b-row>
      <b-col :lg="3">
        <steps :step="invoiceStep" />
      </b-col>
      <b-col :lg="showPdcWidget ? 6 : 7">
        <information
          v-if="invoiceStep === 1"
          :saving="saving"
          :form="formData"
          ref="information"
          :exporterData="exporterData"
        />
        <shipping-details
          v-if="invoiceStep === 2"
          :saving="saving"
          :form="formData"
          :exporterData="exporterData"
        />
        <funding-details
          v-if="invoiceStep === 3"
          :saving="saving"
          :form="formData"
          :exporterData="exporterData"
          @get-pdc-data="getPdcData"
        />
        <upload-docs
          :uploadsSaved="invoiceSaved"
          v-if="invoiceStep === 4"
          @get-pdc-data="getPdcData"
          @updateInvoiceSaved="handleUpdateInvoiceSaved"
        />
        <review v-if="invoiceStep === 5" :exporterData="exporterData" />
        <div :class="showPdcWidget ? '' : 'mb-5 pb-4'"></div>
      </b-col>
      <b-col>
        <data-update-alert-box
          v-if="showMonitoringAlert"
          :date="monitoringData.revoke_date"
          extraClass="flex-column"
        />
      </b-col>
      <b-col v-if="showPdcWidget" :lg="3">
        <pdc-details
          :amount="pdcData.amount"
          :date="pdcData.date"
          :words="pdcData.words"
          class="mb-3"
        />
      </b-col>
    </b-row>
  </section>
</template>
<script>
import Information from '@/components/invoices/Add/Forms/Information'
import FundingDetails from '@/components/invoices/Add/Forms/Funding'
import ShippingDetails from '@/components/invoices/Add/Forms/Shipping'
import UploadDocs from '@/components/invoices/Add/Forms/Upload'
import Review from '@/components/invoices/Add/Forms/Review'
import Steps from '@/components/invoices/Add/Steps'
import { mapState, mapActions } from 'vuex'
import exportersService from '@/services/exporters'
import PdcDetails from '@/components/PdcDetails.vue'
import invoiceService from '@/services/invoice'
import userService from '@/services/user'
import { uploadFilesBus } from '../../../main'
import DataUpdateAlertBox from '@/components/common/DataUpdateAlertBox'
import monitoringService from '@/services/monitoring'

export default {
  errorCaptured: function (err) {
    console.log('Caught error', err.message)
  },
  data() {
    return {
      saving: false,
      monitoringData: null,
      invoiceSaved: [
        {
          index: 0,
          editable: true,
          visible: true,
          vIndex: 0,
          exporter_user_id: '',
          commercial_invoice: [],
          shipping_bill_s_india: [],
          purchase_order_s: [],
          bill_s_of_lading: [],
          pedimento: [],
          packing_list: [],
          task_flows: [],
          errorMessage: ''
        }
      ],
      exporterData: {
        outstanding_invoices: [],
        clients_locked: []
      },
      form: {
        exporter_user_id: this.$store.state.account.accountId,
        importer_user_id: '',
        currency: '',
        reference: null,
        advance_received: 0,
        gross_value: '',
        invoice_date: '',
        user_due_date: '',
        shipping_bill_date: '',
        shipping_bill_number: '',
        bl_no: '',
        bl_date: '',
        container: '',
        shipping_line: '',
        consignee: '',
        customer_buyer_name: '',
        vessel_name: '',
        client_bank_detail_id: '',
        customer_notes: '',
        value: null
      },
      showPdcWidget: false,
      pdcData: {
        amount: '',
        date: '',
        words: ''
      }
    }
  },
  mounted() {
    this.fetchMonitoringData()
  },
  computed: {
    ...mapState({
      invoiceStep: (state) => state.invoice.invoiceStep,
      formData: (state) => state.invoice.formData
    }),
    showMonitoringAlert() {
      if (
        !!this.monitoringData &&
        !!this.monitoringData?.mail_date &&
        this.$moment(this.monitoringData?.revoke_date).isValid() &&
        this.$moment(this.monitoringData?.mail_date).isValid() &&
        (!this.monitoringData.financials.active ||
          !this.monitoringData?.gst.active)
      ) {
        const mailDate = new Date(this.monitoringData.mail_date) // Convert to Date object
        const currentDate = new Date() // Get today's date

        // Calculate the date 45 days after the mail_date
        const days30AfterMailDate = new Date(mailDate)
        days30AfterMailDate.setDate(mailDate.getDate() + 30)

        // Check if today's date is past the 45-day mark
        return (
          currentDate > days30AfterMailDate ||
          currentDate > new Date(this.monitoringData?.revoke_date)
        )
      }
      return false
    }
  },
  created() {
    this.unsetInvoice()
    this.getData()
    this.setStep(this.$route.params.value || 'basic-info')
    this.setFormData(this.formData || this.form)
    uploadFilesBus.$on('addDocument', this.handleAddDocument)
    uploadFilesBus.$on('removeDocument', this.handleRemoveDocument)
  },
  beforeDestroy() {
    uploadFilesBus.$off('addDocument', this.handleAddDocument)
    uploadFilesBus.$off('removeDocument', this.handleRemoveDocument)
  },
  methods: {
    handleAddDocument(documentData, callback) {
      if (
        documentData.docTag &&
        documentData.id &&
        this.invoiceSaved[0][documentData.docTag]
      ) {
        this.invoiceSaved[0][documentData.docTag].push({
          docId: documentData.id,
          name: documentData.name,
          url: documentData.url,
          tag: documentData.tag
        })
        this.$mpTrack('Add Bank - File uploaded (by type)', {
          docId: documentData.id,
          name: documentData.name,
          tag: documentData.docTag,
          url: documentData.url
        })
        if (callback) {
          callback()
        }
      }
    },
    async callRemoveDocumentAPI(invoiceId, documentId, key, callback) {
      await invoiceService
        .removeInvoiceDocument(invoiceId, documentId)
        .then((res) => {
          if (res && key) {
            this.invoiceSaved[0][key] = this.invoiceSaved[0][key].filter(
              (el) => {
                return el.docId !== documentId
              }
            )
            if (callback) {
              callback()
            }
          }
        })
        .catch((e) => {
          this.$notify({
            title: e?.response?.data?.error || this.$t('error.unableToProcess'),
            type: 'error'
          })
        })
    },
    async handleRemoveDocument(index, key, documentId, callback) {
      if (documentId && key) {
        const invoiceId = this.$route.params.id
        this.callRemoveDocumentAPI(invoiceId, documentId, key, callback)
        this.$mpTrack('Add Invoice - File removed', {
          docId: documentId,
          type: key
        })
      } else {
        console.error('Error: document id and key missing')
      }
    },
    handleUpdateInvoiceSaved(newArrayValue) {
      this.invoiceSaved = newArrayValue
    },
    getPdcData() {
      if (!this.showPdcWidget) {
        userService.fetchAccessToken().then((res1) => {
          invoiceService
            .getPdcDetails(this.$route.params.id, res1.data.token)
            .then((res) => {
              this.showPdcWidget = true
              this.pdcData.amount = res.data.pdc_value.split('INR')[1]
              this.pdcData.date = res.data.pdc_date
              this.pdcData.words = res.data.pdc_value_in_words
            })
        })
      }
    },
    getBuyerFromId(id) {
      return this.exporterData.clients_locked.find((element) => {
        return id === element.importer_user_id
      })
    },
    getData() {
      return exportersService
        .fetchExporterMetaData(this.$store.state.account.accountId, {
          include: ['clients_locked', 'bank_details', 'outstanding_invoices']
        })
        .then((res) => {
          this.exporterData = res.data
          if (
            this.$store.state.invoice.invoiceStep === 1 &&
            this.$refs.information
          ) {
            this.$refs.information.checkInvoiceStatus()
          }
        })
    },
    ...mapActions(['setStep', 'setFormData', 'unsetInvoice']),
    async fetchMonitoringData() {
      this.loading = true
      try {
        const res = await monitoringService.getMonitoringData(
          this.$store.getters.accountId
        )
        this.monitoringData = res.data
      } catch (error) {
        console.error('Error fetching monitoring data:', error)
        // Optionally set an error message to display to the user
        this.errorMessage = 'Failed to fetch monitoring data. Please try again.'
      } finally {
        this.loading = false // Ensure loading is set to false regardless of success or error
      }
    }
  },
  components: {
    Information,
    ShippingDetails,
    FundingDetails,
    UploadDocs,
    Steps,
    PdcDetails,
    Review,
    DataUpdateAlertBox
  }
}
</script>
<style scoped lang="scss">
:deep(.account-title) {
  font-size: 16px !important;
}
:deep(.account-sub) {
  font-size: 14px !important;
}
:deep(.btn-alert) {
  margin-top: 24px;
}
:deep(.icon-alert) {
  font-size: 20px !important;
}

:deep(a.btn.rf-button.btn-secondary.solid.medium.btn-alert) {
  padding: 0;
}
</style>
